/**
 * DHE notifications opt-in handler (cart page + thank-you page).
 *
 * Activated for each `.dhe-notif-optin` block on the page. Toggling the
 * checkbox reveals the phone row; entering a phone + clicking Subscribe
 * POSTs to dh-connector. The dh-connector proxy normalizes phone via
 * Twilio Lookups and forwards to the engine.
 *
 * Shadow mode on the engine means real SMS is NOT sent — but the opt-in
 * is still recorded with full TCPA audit trail.
 */
(function () {
  'use strict';

  var DHC_ORIGIN = 'https://dh-connector.vercel.app';
  // Two SEPARATE, optional consents (Twilio 30913).
  // Must match the checkbox labels in snippets/dhe-notifications-optin.liquid exactly.
  var MARKETING_TEXT = "Yes, text me deals! I agree to receive recurring automated marketing text messages from Destination Hair Extensions (DHE), a trade name of Hair Pro 360 LLC, at the number provided about drops, launches, and sales. Message frequency varies. Consent is not a condition of purchase. See our Privacy Policy and Terms of Service.";
  var TRANSACTIONAL_TEXT = "Text me order updates. I agree to receive text messages from Destination Hair Extensions (DHE), a trade name of Hair Pro 360 LLC, at the number provided about my orders, such as order confirmations and shipping updates. Message frequency varies. See our Privacy Policy and Terms of Service.";
  function dheSmsSuccessText(m, t) {
    if (m && t) return "You\u2019re in! You\u2019ll get texts from DHE about drops, launches, sales, and your orders. Reply STOP at any time to cancel.";
    if (m) return "You\u2019re in! You\u2019ll get texts from DHE about drops, launches, and sales. Reply STOP at any time to cancel.";
    if (t) return "You\u2019re in! You\u2019ll get texts from DHE about your orders. Reply STOP at any time to cancel.";
    return "Thanks! You\u2019re all set.";
  }

  function init(container) {
    // The snippet can be rendered more than once on a page (script loads twice): init once.
    if (container.getAttribute('data-dhe-init') === '1') return;
    container.setAttribute('data-dhe-init', '1');
    var mBox = container.querySelector('.dhe-notif-optin__input--marketing');
    var tBox = container.querySelector('.dhe-notif-optin__input--transactional');
    var phoneRow = container.querySelector('.dhe-notif-optin__phone-row');
    var phoneInput = container.querySelector('.dhe-notif-optin__phone');
    var submit = container.querySelector('.dhe-notif-optin__submit');
    var status = container.querySelector('.dhe-notif-optin__status');

    if (!mBox || !tBox || !phoneRow || !phoneInput || !submit || !status) return;

    function anyTicked() { return mBox.checked || tBox.checked; }

    function setStatus(text, state) {
      status.textContent = text || '';
      if (state) status.setAttribute('data-state', state);
      else status.removeAttribute('data-state');
    }

    function onToggle(e) {
      phoneRow.hidden = !anyTicked();
      setStatus('', null);
      if (e.target.checked) phoneInput.focus();
    }
    mBox.addEventListener('change', onToggle);
    tBox.addEventListener('change', onToggle);

    submit.addEventListener('click', function () {
      var phone = phoneInput.value.trim();
      // The Subscribe button only appears once a box is ticked; never subscribe without one.
      var smsMarketing = mBox.checked;
      var smsTransactional = tBox.checked;
      if (!smsMarketing && !smsTransactional) {
        setStatus("Thanks! You\u2019re all set.", 'ok');
        return;
      }
      var ticked = [];
      if (smsMarketing) ticked.push(MARKETING_TEXT);
      if (smsTransactional) ticked.push(TRANSACTIONAL_TEXT);
      if (phone.replace(/\D/g, '').length < 10) {
        setStatus('Please enter a 10-digit mobile number.', 'error');
        return;
      }

      submit.disabled = true;
      setStatus('Subscribing…', null);

      var source = container.getAttribute('data-source') || 'cart_page';
      var shopifyCustomerId = container.getAttribute('data-shopify-customer-id') || undefined;
      var email = container.getAttribute('data-prefill-email') || undefined;
      var firstName = container.getAttribute('data-prefill-first-name') || undefined;
      var lastName = container.getAttribute('data-prefill-last-name') || undefined;

      fetch(DHC_ORIGIN + '/api/dhe/notifications-optin', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone: phone,
          email: email,
          shopify_customer_id: shopifyCustomerId,
          first_name: firstName,
          last_name: lastName,
          audience: 'retail',
          channel_opt_ins: ['customer_sms'],
          sms_marketing_consent: smsMarketing,
          sms_transactional_consent: smsTransactional,
          marketing_consent_text: MARKETING_TEXT,
          transactional_consent_text: TRANSACTIONAL_TEXT,
          sms_consent: true,
          consent_text: ticked.join(' | '),
          source: source,
        }),
      })
        .then(function (res) {
          return res.json().then(function (body) {
            return { ok: res.ok, status: res.status, body: body };
          });
        })
        .then(function (out) {
          if (out.ok && out.body && out.body.subscriber_id) {
            setStatus(dheSmsSuccessText(smsMarketing, smsTransactional), 'ok');
            mBox.disabled = true;
            tBox.disabled = true;
            phoneInput.disabled = true;
            submit.disabled = true;
          } else {
            var msg = (out.body && out.body.message) || 'Something went wrong. Try again later.';
            setStatus(msg, 'error');
            submit.disabled = false;
          }
        })
        .catch(function () {
          setStatus('Network error. Please try again.', 'error');
          submit.disabled = false;
        });
    });
  }

  function bootstrap() {
    var containers = document.querySelectorAll('.dhe-notif-optin');
    for (var i = 0; i < containers.length; i++) init(containers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
